<template>
    <transition name="fade">
        <div v-if="isVisible"
             class="bg-navy
                    px-6
                    py-3
                    absolute
                    bottom-full
                    left-0
                    w-full
                    text-sm
                    text-center
                    text-white
                    font-book
                    shadow-rev">
            You'll pay:

            <span v-if="cartData.promoPriceTotal !== cartData.firstMonthTotal" class="underline">
                <span class="font-bold">
                    {{ toCurrency(cartData.firstMonthTotal - discountAmount) }}
                </span>
                for your first month
            </span>
            <span v-else class="underline">
                <span class="font-bold">
                    {{ toCurrency(cartData.promoPriceTotal - discountAmount) }}
                </span>
                /mo for {{ promoDuration }} months
            </span>
        </div>
    </transition>
</template>

<script>
    import {mapGetters} from "vuex";
    import products from "../../../../templates/products/_products";

    export default {
        name: 'AppMiniCart',
        props: {
            cartData: {
                type: Object,
                required: true,
            },
            productMetadata: {
                type: String,
                required: false,
                default: "[]",
            },
            isVisible: {
                type: Boolean,
                default: false,
            },
        },
        computed: {
            ...mapGetters({
                isFmf: 'isFmf',
                fmfAmount: 'fmfAmount',
                parseMetadata: 'parseMetadata',
                filterAndMerge: 'filterAndMerge',
                discountAmount: 'discountAmount',
                internet: 'Buyflow/internet/selectedService',
            }),
            productData () {
                return {
                    file: this.parseMetadata(products ?? []),
                    craft: this.parseMetadata(JSON.parse(this.productMetadata) ?? [])
                }
            },
            mergedMetadata() {
                return this.filterAndMerge({base: this.productData.file, override: this.productData.craft})
            },
            promoDuration(){
                const data = this.mergedMetadata[this.internet.name][0]
				return (data?.variants?.customizations?.internet?.products[this.internet.name]?.promoMonths || "12").split(',')[0]
            },
        },
    }
</script>
